import { useMemo, useState } from 'react'
import { useQueryWithStore } from 'react-admin'
import { AppState, User_fields } from 'src/types/globalTypes'

export default function useUsers() {
  const [result, setResult] = useState<User_fields[]>([])

  const { data, total, loading, error } = useQueryWithStore<AppState>({
    type: 'getList',
    resource: 'user',
    payload: {
      sort: { field: 'name', order: 'ASC' },
    },
  })

  let users = useMemo(() => {
    if (data) {
      setResult(data)
    }

    return result
  }, [data, result])

  return {
    data: users,
    total: total || 0,
    loading,
    error,
  }
}
